var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPokerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "poker_2_",
    "data-name": "poker (2)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.39,
    height: 21.39,
    viewBox: "0 0 21.39 21.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1b515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#fffb9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1900b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M160.291,288.208a.627.627,0,0,0-.933.009l-3.566,4.052a.627.627,0,0,0,0,.828l3.566,4.052a.627.627,0,0,0,.933.009L164,293.106a.627.627,0,0,0,0-.846Z",
    transform: "translate(-149.134 -275.973)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3728",
    "data-name": "Path 3728",
    d: "M153.507,0A2.564,2.564,0,0,0,151,2.687c0,1.871,1.728,3.026,3.974,4.991a.627.627,0,0,0,.825,0c2.246-1.965,3.974-3.121,3.974-4.991A2.564,2.564,0,0,0,157.267,0a2.344,2.344,0,0,0-1.88.944A2.344,2.344,0,0,0,153.507,0Z",
    transform: "translate(-144.692 0)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3729",
    "data-name": "Path 3729",
    d: "M6.267,131.52a2.507,2.507,0,0,0,.625-4.934,2.506,2.506,0,1,0-5.01,0,2.506,2.506,0,1,0,1.879,4.6v1.59H3.133a.627.627,0,0,0,0,1.253H5.64a.627.627,0,0,0,0-1.253H5.013v-1.59A2.491,2.491,0,0,0,6.267,131.52Z",
    transform: "translate(0 -118.82)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M306.8,120.406a.627.627,0,0,0-.825,0c-2.246,1.965-3.974,3.121-3.974,4.991a2.564,2.564,0,0,0,2.507,2.687,2.265,2.265,0,0,0,1.253-.367v1.464h-.627a.627.627,0,1,0,0,1.253h2.507a.627.627,0,0,0,0-1.253h-.627v-1.464a2.265,2.265,0,0,0,1.253.367,2.564,2.564,0,0,0,2.507-2.687C310.773,123.527,309.045,122.371,306.8,120.406Z",
    transform: "translate(-289.383 -115.227)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokerIcon);
export default __webpack_public_path__ + "static/media/pokerIcon.b276f701acae4d4fe7268b79a89146ac.svg";
export { ForwardRef as ReactComponent };